import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core";
import { useSelector, useDispatch } from 'react-redux';
import { createCategoryList } from './createCategoryList';
import { editProductCategory } from "../../actions";
import { generatePublicUrl } from "../../urlConfig";

const EditProductCategories = ({
    products,
    slug,
    triggerLabel = "Перенести товары",
    triggerClassName = "",
}) => {
    const category = useSelector((state) => state.category.categories);
    const [open, setOpen] = useState(false);
    const [productIds, setProductIds] = useState([]);
    const [newCategoryId, setNewCategoryId] = useState("");
    const [selectedProductPreview, setSelectedProductPreview] = useState(null);
    const dispatch = useDispatch();

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setProductIds([]);
        setNewCategoryId("");
        setSelectedProductPreview(null);
    };

    const handleProductIdsChange = (event) => {
        setProductIds(event.target.value);
    };

    const handleNewCategoryIdChange = (event) => {
        setNewCategoryId(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!productIds.length || !newCategoryId) {
            return;
        }

        const payload = {
            productIds,
            newCategoryId
        };

        dispatch(editProductCategory(payload, slug)).then(handleClose);
    };

    return (
        <>
            <button
                type="button"
                className={triggerClassName || "editProductCategories__trigger"}
                onClick={handleClickOpen}
            >
                {triggerLabel}
            </button>

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{ className: "editProductCategoriesDialog" }}
            >
                <DialogTitle>Перенести товары в другую категорию</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        Выберите товары и категорию, в которую их нужно перенести.
                    </DialogContentText>

                    <form onSubmit={handleSubmit} className="editProductCategoriesDialog__form">
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Товары</InputLabel>
                            <Select
                                multiple
                                value={productIds}
                                onChange={handleProductIdsChange}
                                renderValue={(selected) => (
                                    selected.length
                                        ? `Выбрано товаров: ${selected.length}`
                                        : "Товары не выбраны"
                                )}
                            >
                                {products.map((prod) => {
                                    const previewImage = prod.productPictures?.[0]?.img || null;

                                    return (
                                        <MenuItem
                                            key={prod._id}
                                            value={prod._id}
                                            onMouseEnter={() => setSelectedProductPreview(previewImage)}
                                            onMouseLeave={() => setSelectedProductPreview(null)}
                                        >
                                            {prod.fullName}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>

                        {selectedProductPreview ? (
                            <div className="editProductCategoriesDialog__preview">
                                <img
                                    src={generatePublicUrl(selectedProductPreview)}
                                    alt=""
                                />
                            </div>
                        ) : null}

                        <FormControl fullWidth margin="normal">
                            <InputLabel>Новая категория</InputLabel>
                            <Select
                                value={newCategoryId}
                                onChange={handleNewCategoryIdChange}
                            >
                                {createCategoryList(category).map((cat) => (
                                    <MenuItem key={cat.value} value={cat.value}>
                                        {cat.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <DialogActions>
                            <Button onClick={handleClose}>
                                Отмена
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                disabled={!productIds.length || !newCategoryId}
                            >
                                Перенести
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default EditProductCategories;
